import { Component, forwardRef, OnInit } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ProductPickupClient, GetListProductPickupRequest } from '../../api-connector/sso-connector';
import { BaseAutocompleteControl } from '../base-autocomplete-control';

export interface ProductPickupOption {
    id: string;
    personPickup: string;
    totalOrder: number;
    createdTime: Date;
    date: Date;
}

@Component({
    selector: 'app-product-pickup-search-control',
    templateUrl: './product-pickup-search-control.component.html',
    styleUrls: ['./product-pickup-search-control.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ProductPickupSearchControlComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => ProductPickupSearchControlComponent),
            multi: true,
        }
    ]
})
export class ProductPickupSearchControlComponent extends BaseAutocompleteControl<ProductPickupOption> implements OnInit {

    constructor(private productPickupClient: ProductPickupClient) {
        super();
    }

    ngOnInit(): void {
        if (!this.placeholder || this.placeholder === '---Lựa chọn---') {
            this.placeholder = 'Tìm người bù đơn...';
        }
        super.ngOnInit();
    }

    protected fetchItems(searchValue: string): Observable<ProductPickupOption[]> {
        const request = new GetListProductPickupRequest({
            keySearch: searchValue || '',
            pageIndex: 0,
            pageSize: 20
        });

        return this.productPickupClient.listProductPickup(request).pipe(
            map((response: any) => {
                if (!response?.items) return [];
                return response.items.map((pp: any) => ({
                    id: pp.id?.toString(),
                    personPickup: pp.personPickup || 'N/A',
                    totalOrder: pp.totalOrder || 0,
                    createdTime: pp.createdTime ? new Date(pp.createdTime) : new Date(),
                    date: pp.date ? new Date(pp.date) : new Date()
                }));
            }),
            catchError(() => of([]))
        );
    }

    getDisplayValue(item: ProductPickupOption | null): string {
        return item?.personPickup || '';
    }

    protected isValidItem(value: any): boolean {
        return value && value.id;
    }

    writeValue(obj: any): void {
        if (this.isValidItem(obj)) {
            super.writeValue(obj);
        } else if (obj) {
            const request = new GetListProductPickupRequest({
                keySearch: obj.toString(),
                pageIndex: 0,
                pageSize: 1
            });

            this.productPickupClient.listProductPickup(request).pipe(
                map((response: any) => {
                    if (!response?.items || response.items.length === 0) return null;
                    const pp = response.items[0];
                    return {
                        id: pp.id?.toString(),
                        personPickup: pp.personPickup || 'N/A',
                        totalOrder: pp.totalOrder || 0,
                        createdTime: pp.createdTime ? new Date(pp.createdTime) : new Date(),
                        date: pp.date ? new Date(pp.date) : new Date()
                    };
                }),
                catchError(() => of(null))
            ).subscribe((item: any) => {
                if (item) {
                    super.writeValue(item);
                }
            });
        } else {
            super.writeValue(obj);
        }
    }

    formatCurrency(value: number): string {
        return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(value);
    }

    formatDateTime(date: Date): string {
        if (!date) return '';
        return new Date(date).toLocaleString('vi-VN');
    }
}
